import React, { useState } from 'react'
import logo from '../img/helplogo.jpg'
import './header.css'
import { FaAngleDown, FaHeart } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import Donate from './Donate'

function Header() {

    
    const menuClick =()=>{
        const menu_icon = document.querySelector(".menu-icon")
        menu_icon.classList.toggle("open");
        const menu_dropdown = document.querySelector(".menu_dropDown")
        menu_dropdown.classList.toggle("dropDown");
    }
    
    const donationClick =()=>{
        const menu_dropdown = document.querySelector(".donate_header")
        menu_dropdown.classList.toggle("donate_dropDown");
    }

    const [isHovered, setIsHovered] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [isHover2, setIsHover2] = useState(false);
    const [isHover3, setIsHover3] = useState(false);
    const [isHover4, setIsHover4] = useState(false);

    const fstclick =()=>{
        isHover ? setIsHover(false) : setIsHover(true)
        setIsHover2(false)
        setIsHover3(false)
        setIsHover4(false)
    }

    const secclick =()=>{
        isHover2 ? setIsHover2(false) : setIsHover2(true)
        setIsHover(false)
        setIsHover3(false)
        setIsHover4(false)
    }

    const trdclick =()=>{
        isHover3 ? setIsHover3(false) : setIsHover3(true)
        setIsHover2(false)
        setIsHover(false)
        setIsHover4(false)
    }

    const frtclick =()=>{
        isHover4 ? setIsHover4(false) : setIsHover4(true)
        setIsHover2(false)
        setIsHover3(false)
        setIsHover(false)
    }

  return (
    <div className='header'>
        <div className='desk_header' >
            <Link to={'/'} className='desk_header_logo' >
                <img className='desk_header_img' src={logo} alt='' />
                <h3>THE LORD Nations FOUNDATION</h3>
            </Link>

            <div className='desk_header_links'>
                {
                    isHovered || isHovered2 || isHovered3 || isHovered4 ?
                        <div className='hover_drop_down_overlay'></div>
                    : null
                }
                <div className='desk_header_links_drop'
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                 >
                    <div className='desk_header_links_drop_arrow' 
                    >
                        <h3>WHO WE ARE</h3>
                        <FaAngleDown className='header_icon' />
                    </div>
                    {
                        isHovered ?
                            <div className='hover_drop_down'>
                                <Link className='hover_drop_down_link' to={'/about-us'} >ABOUT US</Link>
                                <Link className='hover_drop_down_link' to={'/contact-us'} >CONTACT US</Link>
                                {/* <Link className='hover_drop_down_link' to={'/our-leadership'} >OUR LEADERSHIP</Link> */}
                            </div>
                        : null
                    }
                </div>

                <div className='desk_header_links_drop'
                        onMouseEnter={() => setIsHovered2(true)}
                        onMouseLeave={() => setIsHovered2(false)} >
                    <div className='desk_header_links_drop_arrow' >
                        <h3>WHAT WE DO</h3>
                        <FaAngleDown className='header_icon' />
                    </div>
                    {
                        isHovered2 ?
                            <div className='hover_drop_down'>
                                {/* <Link className='hover_drop_down_link' to={'/emergencies'} >EMERGENCY</Link> */}
                                <Link className='hover_drop_down_link' to={'/our-work'} >OUR WORK</Link>
                                <Link className='hover_drop_down_link' to={'/our-impact'} >OUR IMPACT</Link>
                            </div>
                        : null
                    }
                </div>

                <div className='desk_header_links_drop'
                    onMouseEnter={() => setIsHovered3(true)}
                    onMouseLeave={() => setIsHovered3(false)}
                >
                    <div className='desk_header_links_drop_arrow' >
                        <h3>JOIN US</h3>
                        <FaAngleDown className='header_icon' />
                    </div>
                    {
                        isHovered3 ?
                            <div className='hover_drop_down'>
                                <Link className='hover_drop_down_link' to={'/donate-now'} >DONATE NOW</Link>
                                <Link className='hover_drop_down_link' to={'/donate-monthly'} >DONATE MONTHLY</Link>
                                <Link className='hover_drop_down_link' to={'/learn-share'} >LEARN & SHARE </Link>
                                <Link className='hover_drop_down_link' to={'/partner-with-us'} >PARTNER WITH US </Link>
                                {/* <Link className='hover_drop_down_link' to={'/contact'} >WORK WITH US </Link> */}
                            </div>
                        : null
                    }
                </div>

                <div className='desk_header_links_drop' 
                    onMouseEnter={() => setIsHovered4(true)}
                    onMouseLeave={() => setIsHovered4(false)}
                >
                    <div className='desk_header_links_drop_arrow' >
                        <h3>LATEST</h3>
                        <FaAngleDown className='header_icon' />
                    </div>
                    {
                        isHovered4 ?
                            <div className='hover_drop_down'>
                                <Link className='hover_drop_down_link' to={'/news'} >NEWS</Link>
                                <Link className='hover_drop_down_link' to={'/stories'} >STORIES</Link>
                            </div>
                        : null
                    }
                </div>
            </div>

            <div onClick={()=>donationClick()} className='desk_header_donate_btn'>
                <FaHeart className='desk_header_donate_btn_icon' />
                <h3>DONATE</h3>
            </div>
        </div>

        <div className='mobile_header' >
            <Link to={'/'} className='desk_header_logo' >
                <img className='desk_header_img' src={logo} alt='' />
                <h3>THE LORD Nations FOUNDATION</h3>
            </Link>
            
            <div className='desk_header_donate_btns'>
                <div onClick={()=>donationClick()} className='desk_header_donate_btn'>
                    <FaHeart className='desk_header_donate_btn_icon' />
                    <h3>DONATE</h3>
                </div>

                <div onClick={menuClick} className="menu-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div className='menu_dropDown' >
                <div className='dropdown_slide_spacer' ></div>
                <div onClick={()=> fstclick()} className='dropdown_slide'>
                    <h3>WHAT WE DO</h3>
                    <FaAngleDown />
                    {
                        isHover ?
                            <div className='click_drop_down'>
                                <Link className='hover_drop_down_link' to={'/about-us'} >ABOUT US</Link>
                                <Link className='hover_drop_down_link' to={'/contact-us'} >CONTACT US</Link>
                                {/* <Link className='hover_drop_down_link' to={'/our-leadership'} >OUR LEADERSHIP</Link> */}
                            </div>
                        : null
                    }
                </div>

                <div onClick={()=> secclick()} className='dropdown_slide'>
                    <h3>JOIN US</h3>
                    <FaAngleDown />
                    {
                        isHover2 ?
                            <div className='click_drop_down'>
                                {/* <Link className='hover_drop_down_link' to={'/emergencies'} >EMERGENCY</Link> */}
                                <Link className='hover_drop_down_link' to={'/our-work'} >OUR WORK</Link>
                                <Link className='hover_drop_down_link' to={'/our-impact'} >OUR IMPACT</Link>
                            </div>
                        : null
                    }
                </div>
                    
                <div onClick={()=> trdclick()} className='dropdown_slide'>
                    <h3>WHO WE ARE</h3>
                    <FaAngleDown />
                    {
                        isHover3 ?
                            <div className='click_drop_down'>
                                <Link className='hover_drop_down_link' to={'/donate-now'} >DONATE NOW</Link>
                                <Link className='hover_drop_down_link' to={'/donate-monthly'} >DONATE MONTHLY</Link>
                                <Link className='hover_drop_down_link' to={'/learn-share'} >LEARN & SHARE </Link>
                                <Link className='hover_drop_down_link' to={'/partner-with-us'} >PARTNER WITH US </Link>
                                {/* <Link className='hover_drop_down_link' to={'/contact'} >WORK WITH US </Link> */}
                            </div>
                        : null
                    }
                </div>
                <div onClick={()=> frtclick()} className='dropdown_slide'>
                    <h3>LATEST</h3>
                    <FaAngleDown />
                    {
                        isHover4 ?
                            <div className='click_drop_down'>
                                <Link className='hover_drop_down_link' to={'/news'} >NEWS</Link>
                                <Link className='hover_drop_down_link' to={'/stories'} >STORIES</Link>
                            </div>
                        : null
                    }
                </div>

                <div onClick={()=>donationClick()} className='menu_mobile_logbtn'>
                    <h3>DONATE</h3>
                </div>
            </div>
        </div>

        <div className='donate_header' > 
            <div className="close_donate_container">
                <div onClick={()=>donationClick()}  className="close_donate">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className='donate_header_container'>
                <div className='donate_img' >
                    <div className='donate_img_overlay'>
                        <h1>Join Us in Changing Lives</h1>
                        <p>Every contribution, no matter how small, brings hope and opportunity to orphaned children. Together, we can build a better future.</p>
                    </div>
                </div>

                <div className='donate_dropDown' >
                    <Donate />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Header